(function () {
    const quantityContainer = document.querySelector(".quantity");
    if (quantityContainer) {
        const minusBtn = quantityContainer.querySelector(".minus");
        const plusBtn = quantityContainer.querySelector(".plus");
        const inputBox = quantityContainer.querySelector(".input-box");

        updateButtonStates();

        quantityContainer.addEventListener("click", handleButtonClick);
        inputBox.addEventListener("input", handleQuantityChange);

        function updateButtonStates() {
            const value = parseInt(inputBox.value);
            minusBtn.disabled = value <= 1;
            plusBtn.disabled = value >= parseInt(inputBox.max);
        }

        function handleButtonClick(event) {
            event.preventDefault();
            if (event.target.classList.contains("minus")) {
                decreaseValue();
            } else if (event.target.classList.contains("plus")) {
                increaseValue();
            }
        }

        function decreaseValue() {
            let value = parseInt(inputBox.value);
            value = isNaN(value) ? 1 : Math.max(value - 1, 1);
            inputBox.value = value;
            updateButtonStates();
            handleQuantityChange();
        }

        function increaseValue() {
            let value = parseInt(inputBox.value);
            value = isNaN(value) ? 1 : Math.min(value + 1, parseInt(inputBox.max));
            inputBox.value = value;
            updateButtonStates();
            handleQuantityChange();
        }

        function handleQuantityChange() {
            let value = parseInt(inputBox.value);
            value = isNaN(value) ? 1 : value;

            // Execute your code here based on the updated quantity value
            console.log("Quantity changed:", value);
        }
    }

    const denominationDiv = document.querySelector('.denomination');

    if (denominationDiv) {
        const links = Array.from(denominationDiv.querySelectorAll('a, span'));

        // Sort links based on data-price (ascending order)
        links.sort((a, b) => {
            const priceA = parseInt(a.dataset.price, 10);
            const priceB = parseInt(b.dataset.price, 10);
            return priceA - priceB;
        });

        // Remove existing links from the DOM
        links.forEach(link => denominationDiv.removeChild(link));

        // Append sorted links back to the DOM
        links.forEach(link => denominationDiv.appendChild(link));

        // Show the denomination div after sorting is complete
        denominationDiv.style.display = 'flex';
    }

    const input = document.getElementById("customDenomination");
    const buyNowBtn = document.getElementById("buyNowBtn");
    const priceSpan = document.getElementById("ProductPriceSpan");

    // Function to format the number as "5,00"
    function formatPrice(value) {
        return `${value},00`;
    }

    // Function to validate input and toggle button state
    function validateDenomination() {
        const denomination = parseInt(input.value, 10);
        const isValid = !isNaN(denomination) && denomination >= 10 && denomination <= 150;

        buyNowBtn.disabled = !isValid;

        if (isValid) {
            priceSpan.textContent = formatPrice(denomination);
        }
    }

    if (input) {
        // Validate on input change
        input.addEventListener("input", validateDenomination);

        // Initial validation check on page load
        validateDenomination();
    }

    if (buyNowBtn) {
        buyNowBtn.addEventListener("click", async function () {
            const denomination = parseInt(input.value, 10);

            // Define product handle
            const productHandle = denomination <= 100 ? "paysafecard-variable" : "paysafecard-variable-2";

            try {
                // Step 1: Clear the cart.
                const clearResponse = await fetch('/cart/clear.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (!clearResponse.ok) {
                    throw new Error('Failed to clear cart.');
                }

                // Fetch product JSON *after* clearing the cart.
                const productResponse = await fetch(`/products/${productHandle}.json`);
                const productData = await productResponse.json();

                // Find the correct variant
                const variant = productData.product.variants.find(v => parseInt(v.option1, 10) === denomination);

                if (!variant) {
                    alert("Kein passender Variant gefunden!");
                    return;
                }

                // Step 2: Add to cart and redirect to checkout
                const addResponse = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] }) // Use items array
                });

                if (!addResponse.ok) {
                    const errorData = await addResponse.json(); // Get error details
                    throw new Error(errorData.description || 'Failed to add item to cart.');
                }

                window.location.href = "/checkout";

            } catch (error) {
                console.error("Error:", error);
                alert("Fehler: " + error.message); // Display specific error message.
            }
        });
    }

    const priceSpans = document.querySelectorAll('.variable-denom span[data-price]');
    const customDenominationInput = document.getElementById('customDenomination');

    if (priceSpans) {
        priceSpans.forEach(span => {
            span.addEventListener('click', function() {
                const price = this.dataset.price;
                customDenominationInput.value = price;
                validateDenomination();
            });
        });
    }

})();

function buyNow() {
    const variantId = document.querySelector('.product-single__variants').value;
    const quantity = 1; // Always 1 for Buy Now

    // Step 1: Clear the cart.
    fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(response => {
            if (!response.ok) {
                throw new Error('Failed to clear cart.');
            }
            return response.json();
        })
        .then(() => {
            // Step 2: Add the item to the cart using the AJAX API.
            return fetch('/cart/add.js', { // Return the fetch promise!
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: quantity
                    }]
                })
            });
        })
        .then(response => { // This .then() handles the add-to-cart response.
            if (!response.ok) {
                return response.json().then(errorData => {
                    throw new Error(errorData.description || 'Failed to add item to cart.');
                });
            }
            return response.json();
        })
        .then(() => { // This .then() executes after successful add-to-cart.
            // Step 3: Redirect to checkout.
            window.location.href = '/checkout';
        })
        .catch(error => {
            console.error('Error:', error);
            alert(error.message); // User-friendly error message.
        });
}